module.exports = __webpack_public_path__ + "static/img/HOMAYA_PANNEAU_2_LAMPES_2_PORTABLE.599cbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/HOMAYA_PANNEAU_2_LAMPES_2_PORTABLE.jpg
// module id = f8s/
// module chunks = 0